import { z } from 'zod'

export const SheetOperationResultSchema = z.object({
  spreadsheetId: z.string().min(1),
  spreadsheetUrl: z.string().min(1),
  warnings: z.array(z.string()).optional(),
})
export const SheetOperationSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('processing') }),
  z.object({ status: z.literal('review_required') }),
  z.object({ status: z.literal('succeeded'), result: SheetOperationResultSchema }),
])
export const SheetCreationStatusSchema = z.union([
  SheetOperationSchema,
  z.object({ status: z.literal('not_found') }),
])
export const SheetOperationRecordSchema = z
  .object({
    fingerprint: z.string().min(1),
    status: z.enum(['processing', 'review_required', 'succeeded']),
    result: SheetOperationResultSchema.optional(),
    createdAt: z.string(),
    updatedAt: z.string().optional(),
    // Stamped by the converter on every write, as the object shape DocumentVersion
    // defines — not a number. Declaring it wrongly fails validation on every read
    // just as omitting it did: the converter logs and hands back unvalidated data,
    // so the schema stops being a check at all. Same shape as every other record
    // schema here, which is where this should have been read from.
    _version: z.object({ major: z.number(), minor: z.number() }).optional(),
  })
  .strict()

export type SheetResult = z.infer<typeof SheetOperationResultSchema>
export type SheetOperation = z.infer<typeof SheetOperationSchema>
export type SheetCreationStatus = z.infer<typeof SheetCreationStatusSchema>
